export default {
  GENERAL: 'general',
  GROUP: 'group',
  EXCURSION_MANAGEMENT: 'excursion-management',
  PROVIDERS: 'providers',
  CONTENT_ENGINE: 'content-engine',
  STUDENT_MANAGEMENT: 'student-management',
  TEMPLATES: 'templates',
  HUB_MIGRATION: 'hub-migration'
};
